/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions';
import {
    instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptionsFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptionsToJSON,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions';

/**
 * @type FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimes
 * 
 * @export
 */
export type FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimes = FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions;

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimesFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimes {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimesFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimesFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimes {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimesToJSON(json: any): any {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimesToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimesToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimes | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptionsToJSON(value as FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions);
    }

    return {};
}

